// 시안 F 메신저 피부(#2014 f-collab · 구조는 원제품 · 색·크기만). EmbedPage 가 메신저 iframe 문서에 넣는다.
// 왜 CSS 주입인가: MM 서버 DefaultTheme 은 화면에 안 먹고(memory/collab-skin-change-routes-20261021.md:29),
//    같은 오리진 iframe 이라 통제 지점은 그 문서의 style 요소뿐이다(mmModalCss·mmStickerSizeCss 선례).
// 🔴 스티커 버튼·아이콘(.AdvancedTextEditor__action-button · button[aria-label="스티커"] · 그 svg/path)을 겨냥하는 규칙 금지 — r6_06efcfdf53.test.js ④.
// 🔴 MM 은 테마 변수를 <html> 인라인에 둔다 — body 에서 다시 정의한다. :root 에서 계산되는 파생 변수(상단 줄·테두리·투명도 내장)도 전부 다시 적는다
//    (html 에서 Denim 색으로 이미 계산돼 내려오므로 기본 변수만 바꾸면 파생 변수는 남색 그대로다).
// 🔴 --overrideLhsWidth(사용자가 끌어 저장한 채널 목록 폭)는 건드리지 않는다 — 기본값만 바꾼다.
// 🔴 MM 규칙은 #SidebarContainer·.app__body 접두라 우리보다 세고, 화면별 CSS 조각이 우리 style 뒤에 붙는다
//    → 우리 규칙도 같은 접두를 붙여 강도를 맞춘다.
// 🔴 CSS 문자열 안에 /* */ 주석을 넣지 않는다 — 시험 해석기(r6_8fbe555233 등 splitRules)가 주석을 셀렉터로 읽는다.
//    @media 는 단순 (min-width:Npx)·(max-width:Npx) 만 쓴다(같은 해석기가 모르는 조건은 던진다).
// 선택자는 MM v11.8.0 소스 기준 — 판 올림 때 클래스가 바뀌면 조용히 빠진다(memory/mm-upgrade-impact-20260923.md).
export const MM_FSKIN_STYLE_ID = 'gw-mm-fskin';
export const MM_FSKIN_MID_CLASS = 'gw-mid';   // 게이트웨이 화면 폭 901~1200(시안 줄 26 구간)

// MM 알림 권한 안내 띠(하늘색) — 게이트웨이가 MM 자체 알림을 끄고(muteMmNotifications) 게이트웨이 푸시로 알리므로 숨긴다.
// 이 띠는 className 없는 type=ANNOUNCEMENT 라 클래스가 announcement-bar 하나뿐 → CSS 로 못 고르고 문구로 고른다.
// MM 은 이 키가 'true' 면 띠를 안 그린다(constants.tsx:816 · browser_store.tsx:100-104 · 로그아웃 때 지워진다 → onLoad 마다 넣는다).
export const MM_NOTIFY_BANNER_KEY = 'hideNotificationPermissionRequestBanner';
export const MM_NOTIFY_BANNER_TEXTS = [
  '브라우저에 알림을 표시하려면 사용자의 권한이 필요합니다',          // MM ko.json:3169
  'We need your permission to show notifications in the browser',   // MM en.json:3713
];

const RGB_FG = '50,49,46';          // #32312e
const RGB_WHITE = '255,255,255';    // #ffffff
const RGB_BLUE = '35,131,226';      // #2383e2
const RGB_SIDEBAR = '247,247,245';  // #f7f7f5

// ① 테마 변수(g2-016) — [이름, 값, -rgb 값]. MM applyTheme 이 html 인라인에 쓰는 값들을 body 에서 다시 정의한다.
const MM_FSKIN_THEME_VARS = [
  ['sidebar-bg', '#f7f7f5', RGB_SIDEBAR],
  ['sidebar-text', '#32312e', RGB_FG],
  ['sidebar-unread-text', '#32312e', RGB_FG],
  ['sidebar-text-hover-bg', '#efefed', '239,239,237'],
  ['sidebar-text-active-border', '#2383e2', RGB_BLUE],
  ['sidebar-text-active-color', '#32312e', RGB_FG],
  ['sidebar-header-bg', '#f7f7f5', RGB_SIDEBAR],
  ['sidebar-teambar-bg', '#ffffff', RGB_WHITE],
  ['sidebar-header-text-color', '#32312e', RGB_FG],
  ['center-channel-bg', '#ffffff', RGB_WHITE],
  ['center-channel-color', '#32312e', RGB_FG],
  ['center-channel-text', '#32312e', RGB_FG],
  ['button-bg', '#2383e2', RGB_BLUE],
  ['button-color', '#ffffff', RGB_WHITE],
  ['link-color', '#2383e2', RGB_BLUE],
  ['mention-bg', '#2383e2', RGB_BLUE],
  ['mention-color', '#ffffff', RGB_WHITE],
  // :root 에서 계산되는 파생 — 상단 줄(_css_variables.scss:92-95)
  ['global-header-background', '#ffffff', RGB_WHITE],
  ['global-header-text', '#32312e', RGB_FG],
];

// :root 에서 계산되는 파생 — 테두리(_css_variables.scss:87-89). 테두리 «전체 값»(solid 1px …)이다.
const MM_FSKIN_BORDER_VARS = [
  ['border-default', 'solid 1px #eeeeec'],
  ['border-light', 'solid 1px #eeeeec'],
  ['border-dark', 'solid 1px #e5e5e2'],
];

// 투명도 내장 변수 — MM v11.8.0 webapp/channels/src/utils/utils.tsx applyTheme «Legacy variables with baked in opacity».
// [이름, 바탕 테마 변수, 불투명도]. 🔴 불투명도는 이름의 숫자가 아니라 소스 changeOpacity 인자 값이다(button-bg-30 = 0.32).
// error-text-08·error-text-12 2개는 body 에 바탕 -rgb 가 없어 뺀다(Denim 값 유지 · 설계 rev.3 L1).
export const MM_FSKIN_OPACITY_VARS = [
  ['sidebar-text-08', 'sidebar-text', 0.08],
  ['sidebar-text-16', 'sidebar-text', 0.16],
  ['sidebar-text-30', 'sidebar-text', 0.3],
  ['sidebar-text-40', 'sidebar-text', 0.4],
  ['sidebar-text-50', 'sidebar-text', 0.5],
  ['sidebar-text-60', 'sidebar-text', 0.6],
  ['sidebar-text-72', 'sidebar-text', 0.72],
  ['sidebar-text-80', 'sidebar-text', 0.8],
  ['sidebar-header-text-color-80', 'sidebar-header-text-color', 0.8],
  ['center-channel-bg-88', 'center-channel-bg', 0.88],
  ['center-channel-color-88', 'center-channel-color', 0.88],
  ['center-channel-bg-80', 'center-channel-bg', 0.8],
  ['center-channel-color-80', 'center-channel-color', 0.8],
  ['center-channel-color-72', 'center-channel-color', 0.72],
  ['center-channel-bg-64', 'center-channel-bg', 0.64],
  ['center-channel-color-64', 'center-channel-color', 0.64],
  ['center-channel-bg-56', 'center-channel-bg', 0.56],
  ['center-channel-color-56', 'center-channel-color', 0.56],
  ['center-channel-color-48', 'center-channel-color', 0.48],
  ['center-channel-bg-40', 'center-channel-bg', 0.4],
  ['center-channel-color-40', 'center-channel-color', 0.4],
  ['center-channel-bg-30', 'center-channel-bg', 0.3],
  ['center-channel-color-32', 'center-channel-color', 0.32],
  ['center-channel-bg-20', 'center-channel-bg', 0.2],
  ['center-channel-color-20', 'center-channel-color', 0.2],
  ['center-channel-bg-16', 'center-channel-bg', 0.16],
  ['center-channel-color-24', 'center-channel-color', 0.24],
  ['center-channel-color-16', 'center-channel-color', 0.16],
  ['center-channel-bg-08', 'center-channel-bg', 0.08],
  ['center-channel-color-08', 'center-channel-color', 0.08],
  ['center-channel-color-04', 'center-channel-color', 0.04],
  ['link-color-08', 'link-color', 0.08],
  ['button-bg-88', 'button-bg', 0.88],
  ['button-color-88', 'button-color', 0.88],
  ['button-bg-80', 'button-bg', 0.8],
  ['button-color-80', 'button-color', 0.8],
  ['button-bg-72', 'button-bg', 0.72],
  ['button-color-72', 'button-color', 0.72],
  ['button-bg-64', 'button-bg', 0.64],
  ['button-color-64', 'button-color', 0.64],
  ['button-bg-56', 'button-bg', 0.56],
  ['button-color-56', 'button-color', 0.56],
  ['button-bg-48', 'button-bg', 0.48],
  ['button-color-48', 'button-color', 0.48],
  ['button-bg-40', 'button-bg', 0.4],
  ['button-color-40', 'button-color', 0.4],
  ['button-bg-30', 'button-bg', 0.32],
  ['button-color-32', 'button-color', 0.32],
  ['button-bg-24', 'button-bg', 0.24],
  ['button-color-24', 'button-color', 0.24],
  ['button-bg-16', 'button-bg', 0.16],
  ['button-color-16', 'button-color', 0.16],
  ['button-bg-08', 'button-bg', 0.08],
  ['button-color-08', 'button-color', 0.08],
  ['button-bg-04', 'button-bg', 0.04],
  ['button-color-04', 'button-color', 0.04],
];

const THEME_RGB = MM_FSKIN_THEME_VARS.reduce((acc, v) => { acc[v[0]] = v[2]; return acc; }, {});

const BODY_VARS = []
  .concat(MM_FSKIN_THEME_VARS.map((v) => '--' + v[0] + ':' + v[1] + ';--' + v[0] + '-rgb:' + v[2]))
  .concat(MM_FSKIN_BORDER_VARS.map((v) => '--' + v[0] + ':' + v[1]))
  .concat(MM_FSKIN_OPACITY_VARS.map((v) => '--' + v[0] + ':rgba(' + THEME_RGB[v[1]] + ',' + v[2] + ')'))
  .join(';');

const SHADOW = '0 2px 6px #1c191709,0 1px 2px #1c191705';   // 시안 --shadow

export const MM_FSKIN_CSS = [
  // ① 테마 변수(g2-016) — body 에서 다시 정의(MM 은 html 인라인에 둔다 → body 값이 그 아래에서 이긴다 · !important 불필요)
  'body{' + BODY_VARS + '}',
  // ② 상단 줄(g2-017)
  '#global-header{background:#ffffff;border-bottom:1px solid #eeeeec}',
  // ③ 채널 목록(g2-018) — MM 과 같은 id 접두로 강도를 맞춘다. 폭은 769 이상(MM 데스크톱 구간)에서만 · 기본값만 바꾼다.
  //    1100 구간(html.gw-mid = 게이트웨이 창 폭 901~1200)은 190 — MM min-width 200 도 내려야 나온다.
  '.app__body .main-wrapper{border-radius:0;margin:0;border:0}',
  '@media (min-width:769px){',
  'body #SidebarContainer{width:var(--overrideLhsWidth,216px);border-right:1px solid #eeeeec}',
  'html.' + MM_FSKIN_MID_CLASS + ' body #SidebarContainer{width:var(--overrideLhsWidth,190px);min-width:190px}',
  '}',
  '#SidebarContainer .SidebarChannel .SidebarLink{height:32px;border-radius:5px;font-size:13px;color:#64635f}',
  '#SidebarContainer .SidebarChannel.active .SidebarLink{background:#eaeae7;font-weight:600;color:#32312e}',
  '#SidebarContainer .SidebarChannel.active .SidebarLink::before{display:none}',
  '#SidebarContainer .SidebarChannelGroupHeader_groupButton{font-size:11px;color:#92918d;text-transform:none}',
  // ④ 채널 머리(g2-019)
  '#channel-header{border-bottom:1px solid #eeeeec}',
  // 17px 글자가 MM 의 20px·overflow:hidden 상자에 윗부분이 잘린다(#2781) → 상자를 22px 로
  '#channel-header #channelHeaderTitle{font-size:17px;font-weight:650;line-height:22px;height:22px}',
  // ⑤ 본문 평면
  '.app__body #channel_view{border-radius:0 !important;box-shadow:none !important}',
  // ⑥ 메시지 행(g2-020) — 시안 줄 20(본문 13px/1.8 · 구분선 10px)
  '.app__body .post .col.col__name{font-size:13px;font-weight:650}',
  '.app__body .post .post__time{font-size:10px;opacity:1;color:#92918d}',
  '.app__body .post .post__body{font-size:13px;line-height:1.8}',
  '.app__body .Separator .separator__text{font-size:10px;font-weight:400;color:#92918d;background:transparent}',
  '.app__body .Separator .separator__hr{border-color:#eeeeec;background:#eeeeec}',
  // ⑦ 첨부 카드(g2-021)
  '.app__body .post-image__column{width:auto;min-width:230px;max-width:100%;border:1px solid #e5e5e2;border-radius:6px;box-shadow:' + SHADOW + '}',
  '.app__body .post-image__name{font-size:12px;font-weight:500}',
  // ⑧ 입력창(g2-022) — 실제 상자(__body)만 · 데스크톱만 · 안쪽 단추·아이콘은 겨냥하지 않는다
  '@media (min-width:769px){',
  '#create_post .AdvancedTextEditor__body{border:1px solid #e5e5e2;border-radius:7px;box-shadow:' + SHADOW + '}',
  '}',
  '#post_textbox{font-size:13px}',
  // ⑨ 모바일(g2-023) — 시안 줄 28(≤600)
  '@media (max-width:600px){',
  '#channel-header #channelHeaderTitle{font-size:16px}',
  '.app__body .post .post__body,.app__body .post .col.col__name{font-size:12px}',
  '.app__body .post-image__column{min-width:0}',
  '.app__body .post-image__name{font-size:11px}',
  '}',
].join('');

// 알림 권한 띠 — 다음 렌더부터는 localStorage 로 안 그려지게 하고, 이미 그려진 첫 렌더분은 문구가 맞는 띠만 숨긴다.
// 관리자 공지(admin-announcement) 등 다른 띠는 그대로 둔다. 저장소 접근 예외(차단·opaque 출처)는 삼킨다.
function hideNotifyPermissionBanner(doc) {
  try {
    const w = doc.defaultView;
    const store = w && w.localStorage;
    if (store && store.getItem(MM_NOTIFY_BANNER_KEY) !== 'true') store.setItem(MM_NOTIFY_BANNER_KEY, 'true');
  } catch (e) { /* 저장소 접근 불가 — 무시(아래 문구 숨김은 그대로 한다) */ }
  try {
    const bars = doc.querySelectorAll('.announcement-bar');
    for (let i = 0; i < bars.length; i += 1) {
      const bar = bars[i];
      if (bar.classList && bar.classList.contains('admin-announcement')) continue;
      const text = bar.textContent || '';
      if (!MM_NOTIFY_BANNER_TEXTS.some((t) => text.indexOf(t) >= 0)) continue;
      if (bar.style.display !== 'none') bar.style.display = 'none';
    }
  } catch (e) { /* 로드 중 문서 — 무시 */ }
}

// style#gw-mm-fskin 을 head 끝에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad+화면 폭 변화에서 반복 호출되므로
// 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// midMatches = 게이트웨이 창 폭이 901~1200 구간인가(iframe 폭이 아니다) → html.gw-mid 토글.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — applyMmModalCss 와 같은 형태.
export function applyMmFSkin(doc, midMatches) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_FSKIN_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_FSKIN_CSS) found.textContent = MM_FSKIN_CSS;
  } else {
    const st = doc.createElement('style');
    st.id = MM_FSKIN_STYLE_ID;
    st.textContent = MM_FSKIN_CSS;
    doc.head.appendChild(st);
  }
  if (doc.documentElement) doc.documentElement.classList.toggle(MM_FSKIN_MID_CLASS, !!midMatches);
  hideNotifyPermissionBanner(doc);
}
